import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
// Box padding / radius per size
var sizeBoxClassMap = {
  small: 'rounded-[4px] px-[4px] py-[1px]',
  medium: 'rounded px-[6px] py-[2px]',
  large: 'rounded-[6px] px-[8px] py-[3px]'
}; // Label font size per size

var sizeLabelClassMap = {
  small: 'text-[10px]',
  medium: 'text-xs',
  large: 'text-sm'
};

var JoveTagItemView = function JoveTagItemView(props) {
  var className = props.className,
      label = props.label,
      color = props.color,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size;

  var _useState = useState({}),
      dynamicStyles = _useState[0],
      setDynamicStyles = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    var bgColor = '#0E35D1';

    if (color === 'success') {
      bgColor = '#1CB258';
    } else if (color === 'fail') {
      bgColor = '#DD1F1F';
    }

    setDynamicStyles({
      backgroundColor: bgColor
    });
  }, [color]);
  return /*#__PURE__*/_jsx(Box, {
    className: clsx('inline-flex flex-row', sizeBoxClassMap[size], className),
    sx: dynamicStyles,
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "caption",
      className: clsx('font-bold text-white', sizeLabelClassMap[size]),
      children: label
    })
  });
};

export default JoveTagItemView;